export const environment = {
  baseApiUrl: "https://api.dakwerkendevidt.be",
  apiKey: "35cc56aa-bc89-486f-933a-1306f288bf5a",
  isDebug: false,
};
